import { CSSProperties } from "react";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { ReactComponent as Phone } from "../images/phone_white.svg";
import { ReactComponent as Email } from "../images/mail.svg";
import { logEvent, AnalyticsAction } from "../utils/analytics";

const DesktopModalBox: CSSProperties = {
  maxWidth: "420px",
  height: "100%",
  position: "absolute",
  right: "0",
  top: "0",
  background: "white",
  display: "block",
  padding: "2rem"
};

const MobileModalBox: CSSProperties = {
  background: "white",
  padding: "2rem",
  border: "solid 1px black",
  borderRadius: "5px",
}

const phoneButtonStyle: CSSProperties = {
  width: "100%",
  marginTop: ".5em"
}

const emailButtonStyle: CSSProperties = {
  width: "100%",
  marginTop: ".5em",
  textDecoration: "underline"
}

type ContactUsProps = {
  isMobile: boolean;
  isOpen: boolean;
  toggle: () => void;
}

export default function ContactUs({isMobile, isOpen, toggle}: ContactUsProps) {
  const { t } = useTranslation();

  const handlePhoneClick = () => {
    logEvent(AnalyticsAction.ClickContactPhone);
  };

  const handleFrontRangeEmailClick = () => {
    logEvent(AnalyticsAction.ClickContactEmailFrontRange);
  };

  const handleWesternSlopeEmailClick = () => {
    logEvent(AnalyticsAction.ClickContactEmailWesternSlope);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} boxStyling={isMobile ? MobileModalBox : DesktopModalBox} showCloseX={true}>
      {
        isMobile ? 
        <h1 style={{fontWeight: "bold"}}>{t("contactUs")}</h1> 
        : 
        <h3>{t("contactUs")}</h3>
      }
      <ReactMarkdown>{t("contactUsText")}</ReactMarkdown><br/>
      <div>
        <a rel="noopener noreferrer" target="_blank" className="usa-button usa-button-alt" style={phoneButtonStyle} href="tel:1-844-265-4387" onClick={handlePhoneClick}><Phone></Phone> {t("contactUsCall")}</a><br/>
      </div>
      <br/>
      <div>
        {t("contactFrontRange")}<br/>
        <a rel="noopener noreferrer" target="_blank" className="usa-button usa-button-alt" style={emailButtonStyle} href={"mailto:findcare@signalbhn.org?subject=" + t("mailtoSubject") + "&body=" + t("mailtoBody")} onClick={handleFrontRangeEmailClick}><Email></Email> findcare@signalbhn.org</a>
      </div>
      <br/>
      <div>
        {t("contactWesternSlope")}<br/>
        <a rel="noopener noreferrer" target="_blank" className="usa-button usa-button-alt" style={emailButtonStyle} href={"mailto:rmhp.bhaso@uhc.com?subject=" + t("mailtoSubject") + "&body=" + t("mailtoBody")} onClick={handleWesternSlopeEmailClick}><Email></Email> rmhp.bhaso@uhc.com</a>
      </div>
    </Modal>
  );
}
      
        